// extracted by mini-css-extract-plugin
export default {"page":"G4XCq","loading":"KLzht","rotate":"hjVIA","circle":"BjRUc","animate":"Vvodq","footer":"uEbcB"};